import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Deals from './components/Deals';
import Places from './components/Places';
import Features from './components/Features';
import ForCafes from './components/ForCafes';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import { BusinessSignup } from './components/BusinessSignup';
import Privacy from './components/Privacy';
import Terms from './components/Terms';

function HomePage() {
  return (
    <BusinessSignup>
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <Deals />
        <Places />
        <Features />
        <ForCafes />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
    </BusinessSignup>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </Router>
  );
}

export default App;
